export const INTERVIEW = "interview";
export const LINK = "url";
export const PATHFINDER = "pathfinder";
export const SLIDESHOW = "slideshow";
export const STORY = "story";
export const VIDEO = "video";
